import { render, staticRenderFns } from "./EventItemTab.vue?vue&type=template&id=406e6fa0&scoped=true&"
import script from "./EventItemTab.vue?vue&type=script&lang=js&"
export * from "./EventItemTab.vue?vue&type=script&lang=js&"
import style0 from "./EventItemTab.vue?vue&type=style&index=0&id=406e6fa0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406e6fa0",
  null
  
)

export default component.exports